import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  menuList: [],
};

export const sideBarMenuSlice = createSlice({
   name:'sideBarMenu' ,
   initialState,
   reducers:{
    UpdateSidebarMenu:(state,action)=>{
        state.menuList = action.payload
    }
   }
})

export const {UpdateSidebarMenu} = sideBarMenuSlice.actions;
export default sideBarMenuSlice.reducer
